<ion-header>
  <ion-toolbar mode="md">
    <ion-title>{{ titleTranslationKey | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="webOnlyDineIn ? false : true">
  <ion-grid *ngIf="!webOnlyDineIn">
    <ion-row>
      <ion-col class="ion-text-center">
        <h2>{{ primaryMessageTranslationKey | dineinTableLabel: dineinTableContext }}</h2>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="selectedStore && selectedLang && forOnlyAppsDinein">
      <ion-col class="ion-text-center">
        <h5>
          <ion-text *ngIf="app_name"> {{ app_name }} -</ion-text>
          {{
            selectedStore.store_name_mobileorder &&
            selectedStore.store_name_mobileorder[selectedLang]
              ? selectedStore.store_name_mobileorder[selectedLang]
              : selectedStore.store_name_langs &&
                selectedStore.store_name_langs[selectedLang]
              ? selectedStore.store_name_langs[selectedLang]
              : selectedStore.store_name_langs &&
                selectedStore.store_name_langs.el
              ? selectedStore.store_name_langs.el
              : selectedStore.store_name
          }}
        </h5>
      </ion-col>
    </ion-row>
    <ion-grid *ngIf="nativePlatform === 'android'">
      <ng-lottie
        [options]="animationOptionsAndroid"
        (click)="openLink(otherAndroidUrl ? otherAndroidUrl : branchLink)"
      ></ng-lottie>
    </ion-grid>
    <ion-grid *ngIf="nativePlatform === 'ios'">
      <ng-lottie
        [options]="animationOptionsIos"
        (click)="openLink(otherIosUrl ? otherIosUrl : branchLink)"
      ></ng-lottie>
    </ion-grid>
    <ion-grid *ngIf="showDownloadNowButton" class="ion-text-center">
      <ion-button
        (click)="openLink(otherAndroidUrl ? otherAndroidUrl : branchLink)"
        >DOWNLOAD NOW</ion-button
      >
    </ion-grid>
    <ion-grid *ngIf="!nativePlatform">
      <ion-row>
        <ion-col>
          <ng-lottie [options]="animationOptionsIos"></ng-lottie>
        </ion-col>
        <ion-col>
          <ng-lottie [options]="animationOptionsAndroid"></ng-lottie>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center">
          <img
            width="100"
            height="100"
            [src]="'https://data.deliverymanager.gr/' + group + '/qr/qr.png'"
          />
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-row [hidden]="hideSecondMessage">
      <ion-col>
        <p>
          <span> ή </span>
        </p>
      </ion-col>
    </ion-row>
    <ion-row [hidden]="hideSecondMessage">
      <ion-col class="ion-text-center">
        {{ "open_camera_and_scan_table_qr" | dineinTableLabel: dineinTableContext }}
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid *ngIf="webOnlyDineIn">
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-grid style="max-width: 300px">
          <ng-lottie [options]="animationOptionsWebOnlyDineIn"></ng-lottie>
        </ion-grid>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        <h2>{{ primaryMessageTranslationKey | dineinTableLabel: dineinTableContext }}</h2>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
